/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import AccessTimeFilledRoundedIcon from '@mui/icons-material/AccessTimeFilledRounded'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import AssessmentIcon from '@mui/icons-material/Assessment'
import ClearIcon from '@mui/icons-material/Clear'
import CloseIcon from '@mui/icons-material/Close'
import PinDropIcon from '@mui/icons-material/PinDrop'
import PinDropRoundedIcon from '@mui/icons-material/PinDropRounded'
import 'react-multi-date-picker/styles/layouts/mobile.css'
import '../../Style.css'
import {
  Backdrop,
  Box,
  Card,
  CircularProgress,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  IconButton,
  Modal,
  styled,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useMediaQuery,
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import { Dispatch } from '@reduxjs/toolkit'
import axios from 'axios'
import { toFarsiDigits } from 'farsi-digits'
import _ from 'lodash'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import { Circle, MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import InputIcon from 'react-multi-date-picker/components/input_icon'
import TimePicker from 'react-multi-date-picker/plugins/time_picker'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import sf from 'seconds-formater'
import swal from 'sweetalert'

import iranflag12 from '../../assests/icons/12.png'
import iranflag2 from '../../assests/icons/2.png'
import iranflag24 from '../../assests/icons/24.png'
import iranflag48 from '../../assests/icons/48.png'
import iranflag6 from '../../assests/icons/6.png'
import Button from '../../shared/Button'
import InputText from '../../shared/Input'
import { getDateFrom, getDateTo, setDateFrom, setDateTo, setResetDate } from '../../store/date'
import {
  endTrip,
  getListTrips,
  getLoading,
  getOpenTrips,
  getPositionLast,
  lastPosition,
  listTrips,
  openedTrips,
  resetLastPosition,
  resetOpenTrip,
  resetTripsList,
  startTrip,
  tripDelete,
  tripDeleteOpen,
} from '../../store/devices'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

export interface DialogTitleProps {
  id: string
  children?: React.ReactNode
  onClose: () => void
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            left: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

const TripsCarScreen = () => {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }
  const matches = useMediaQuery('(min-width:600px)')
  const { id } = useParams()
  const positionLast = useSelector(getPositionLast)
  const tripsList = useSelector(getListTrips)

  const loading = useSelector(getLoading)
  const listOpenTrips = useSelector(getOpenTrips)
  const dispatch = useDispatch<Dispatch<any>>()
  const [open, setOpen] = React.useState(false)
  const startDate = useSelector(getDateFrom)
  const endDate = useSelector(getDateTo)
  const [open1, setOpen1] = React.useState(false)
  const [open2, setOpen2] = React.useState(false)
  const [open3, setOpen3] = React.useState(false)
  const [open6, setOpen6] = React.useState(false)
  const [trip, setTrip] = React.useState<any>()

  const [address, setAddress] = React.useState()
  const [address1, setAddress1] = React.useState()

  useEffect(() => {
    if (id === undefined) return
    dispatch(openedTrips(id))
  }, [])
  useEffect(() => {
    return () => {
      dispatch(resetOpenTrip)
    }
  }, [])
  const [alignment, setAlignment] = React.useState<string>('')

  const handleChangeToggle = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
    setAlignment(newAlignment)
  }
  const handleYesterdayDay = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.subtract(1, 'day')
    date.subtract(3, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')
    date.add(1, 'day')
    // date.subtract(3, 'hour')
    // date.subtract(30, 'minute')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')
    // if (startDate !== '' && endDate !== '')
    //   dispatch(
    //     getTripsList({
    //       deviceId: location.state.location.state.id,
    //       startDateTime: startDate,
    //       endDateTime: endDate,
    //     }),
    //   )

    dispatch(
      listTrips({
        deviceId: id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setOpen2(false)
    setIsSearch(true)
  }
  const handle12hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })

    date.subtract(15, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')

    date.add(12, 'hour')
    // date.add(30, 'minute')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(
      listTrips({
        deviceId: id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setOpen2(false)
    setIsSearch(true)
  }
  const handle48hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.subtract(2, 'day')
    date.subtract(3, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')
    date.add(2, 'day')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(
      listTrips({
        deviceId: id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setOpen2(false)
    setIsSearch(true)
  }
  const handle6hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })

    date.subtract(9, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')

    date.add(6, 'hour')
    // date.add(30, 'minute')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(
      listTrips({
        deviceId: id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setOpen2(false)
    setIsSearch(true)
  }
  const handle2hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })

    date.subtract(5, 'hour')
    date.subtract(30, 'minute')
    const startDate1 = date.format('YYYY-MM-DD HH:mm')
    date.add(2, 'hour')
    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    // date.add(30, 'minute')

    dispatch(
      listTrips({
        deviceId: id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setOpen2(false)
    setIsSearch(true)
  }
  async function getUsers() {
    try {
      if (positionLast.gps.latitude === '' || positionLast.gps.longitude === '') return
      await axios
        .get(
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `https://api.neshan.org/v5/reverse?lat=${positionLast?.gps?.latitude}&lng=${positionLast?.gps?.longitude}`,
          {
            headers: {
              'Api-Key': 'service.da5f3022ea194c4a97ca9c33cd46efd8',
            },
          },
        )
        .then((response) => {
          setAddress(response.data.formatted_address)
        })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.message
      } else {
        return 'An unexpected error occurred'
      }
    }
  }

  const [startAddress1, setStartAddress1] = useState()
  const [startAddress2, setStartAddress2] = useState()

  useEffect(() => {
    return () => {
      dispatch(resetLastPosition)
      dispatch(resetTripsList)
      dispatch(setResetDate(''))
    }
  }, [])

  // void getUsers()
  const [isSearch, setIsSearch] = useState(false)
  const handleClickOpen2 = () => {
    setOpen2(true)
  }
  void getUsers()
  const handleClickOpen = () => {
    if (listOpenTrips.length === 0) {
      setOpen(true)
      if (id === undefined) return
      dispatch(lastPosition(id))
    } else {
      const a = swal(
        'امکان ثبت سفر جدید تا پایان سفر فعال وجود ندارد',
        'جهت ادامه کلیک کنید',
        'success',
      )
    }
  }
  async function getUsers1() {
    try {
      if (positionLast.gps.latitude === '' || positionLast.gps.longitude === '') return
      await axios
        .get(
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `https://api.neshan.org/v5/reverse?lat=${positionLast?.gps?.latitude}&lng=${positionLast?.gps?.longitude}`,
          {
            headers: {
              'Api-Key': 'service.da5f3022ea194c4a97ca9c33cd46efd8',
            },
          },
        )
        .then((response) => {
          setAddress1(response.data.formatted_address)
        })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.message
      } else {
        return 'An unexpected error occurred'
      }
    }
  }
  void getUsers1()

  const handleFinishTrip = () => {
    setOpen1(true)
    if (id === undefined) return
    dispatch(lastPosition(id))
  }
  const handleFinishedTrip = () => {
    dispatch(
      endTrip({
        deviceId: id,
        endPositionId: positionLast?.id,
        endAddress: startAddress2 !== undefined ? startAddress2 : address,
      }),
    )
    setStartAddress1(undefined)
    setOpen1(false)
  }
  const handleSaveTrip = () => {
    dispatch(
      startTrip({
        deviceId: id,
        startPositionId: positionLast?.id,
        startAddress: startAddress1 !== undefined ? startAddress1 : address,
      }),
    )
    setStartAddress1(undefined)
    setOpen(false)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const handleClose1 = () => {
    setOpen1(false)
  }
  const handleClose2 = () => {
    setOpen2(false)
  }
  const handleClose3 = () => {
    setOpen3(false)
  }
  const handleShowTripList = () => {
    if (startDate === '' || endDate === '') {
      const a = swal(
        'تاریخ شروع یا تاریخ پایان سفر انتخاب نشده است',
        'جهت ادامه کلیک کنید',
        'warning',
      )
    } else {
      dispatch(
        listTrips({
          deviceId: id,
          startDateTime: startDate,
          endDateTime: endDate,
        }),
      )

      setIsSearch(true)
      setOpen2(false)
      dispatch(setResetDate(''))
    }
  }
  useEffect(() => {
    if (tripsList?.length === 0) return
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    enqueueSnackbar(
      ` تعداد سفرها در این بازه زمانی ${toFarsiDigits(tripsList?.length)} سفر می باشد `,
      {
        variant: 'success',
      },
    )
  }, [tripsList])
  const [date1, setDate1] = useState<string>()
  function handleChange(dateFrom: any) {
    const date = new DateObject({
      calendar: persian,
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      date: `${dateFrom.year}-${dateFrom.month}-${dateFrom.day} ${dateFrom.hour}:${dateFrom.minute}`,
    })
    const a = date.format('YYYY-MM-DD HH:mm')
    setDate1(a)

    date.subtract(3, 'hour')
    date.subtract(30, 'minute')
    // date.add(1, "days");

    date.convert(gregorian, gregorian_en)

    dispatch(setDateFrom(date.format('YYYY-MM-DD HH:mm')))
  }
  function handleChangeDateTo(dateTo: any) {
    // تغییرات روی تاریخ رو اینجا اعمال کنید
    const date = new DateObject({
      calendar: persian,
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      date: `${dateTo.year}-${dateTo.month}-${dateTo.day} ${dateTo.hour}:${dateTo.minute}`,
    })

    date.subtract(3, 'hour')
    date.subtract(30, 'minute')

    date.convert(gregorian, gregorian_en)

    dispatch(setDateTo(date.format('YYYY-MM-DD HH:mm')))
  }
  const navigate = useNavigate()

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '90%', md: '50%', lg: '50%' },
    height: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    '& .leaflet-popup-content': { fontFamily: 'Vazir' },
  }
  const convertKilometer = (meter: number) => {
    if (meter < 1000) {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return _.split(meter.toString(), '.', 1) + 'متر'
    } else {
      const convert = Math.round(meter / 100) / 10
      const convertation: any = _.split(convert.toString(), '.', 2)
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      const num1 = convertation[1] !== undefined ? convertation[1] * 100 + 'متر' : ''

      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return convertation[0] + 'کیلومتر' + num1
    }
  }
  return (
    <Container fixed maxWidth='xs'>
      <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2, direction: 'ltr' }}>
        <ArrowBackRoundedIcon
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: 'red',
            borderRadius: '50%',
            color: '#fff',

            cursor: 'pointer',
          }}
        />
        <img alt='Logo' src='/images/TinyLogo.png' />
      </Box>

      {address !== undefined && (
        <div>
          <BootstrapDialog
            aria-labelledby='customized-dialog-title'
            onClose={handleClose}
            open={open}
            sx={{ direction: 'rtl', '& .MuiDialog-paper': { width: '400px' } }}
          >
            <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose}>
              {t('screens.TripsCarScreen.new_trip')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Box>
                <Typography>{t('screens.TripsCarScreen.last_location')}</Typography>
                <InputText
                  defaultValue={address}
                  onChange={(e: any) => setStartAddress1(e.target.value)}
                  sx={{ width: '100%' }}
                />
                <Typography>{t('screens.TripsCarScreen.time_last_location')}</Typography>
                <Typography>{shamsi(positionLast?.gps?.dateTime)}</Typography>
              </Box>
            </DialogContent>
            <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box>
                <Button
                  onClick={() => {
                    setOpen6(true)
                  }}
                >
                  <PinDropIcon />
                </Button>
              </Box>
              <Box>
                <Button onClick={handleClose} sx={{ ml: 1 }}>
                  {t('screens.TripsCarScreen.cancel_trip')}
                </Button>
                <Button onClick={handleSaveTrip}>{t('screens.TripsCarScreen.save_trip')}</Button>
              </Box>
            </DialogActions>
          </BootstrapDialog>
        </div>
      )}

      {address1 !== undefined && (
        <div>
          <BootstrapDialog
            aria-labelledby='customized-dialog-title'
            onClose={handleClose1}
            open={open1}
            sx={{ direction: 'rtl', '& .MuiDialog-paper': { width: '400px' } }}
          >
            <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose1}>
              {t('screens.TripsCarScreen.finish_trip')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Box>
                <Typography>{t('screens.TripsCarScreen.location_path_finish')}</Typography>
                <InputText
                  defaultValue={address1}
                  onChange={(e: any) => setStartAddress2(e.target.value)}
                  sx={{ width: '100%' }}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Box>
                <Button onClick={handleClose1} sx={{ ml: 1 }}>
                  {t('screens.TripsCarScreen.cancel_trip')}
                </Button>
                <Button onClick={handleFinishedTrip}>
                  {' '}
                  {t('screens.TripsCarScreen.finish_trip')}
                </Button>
              </Box>
            </DialogActions>
          </BootstrapDialog>
        </div>
      )}
      <Backdrop
        onClick={handleClose}
        open={loading}
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Box>
        <Box sx={{ direction: 'rtl' }}>
          {listOpenTrips.length !== 0 ? (
            <Typography>{t('screens.TripsCarScreen.active_trip')}</Typography>
          ) : (
            <Card sx={{ p: 1, display: 'flex', justifyContent: 'center' }}>
              <Typography>{t('screens.TripsCarScreen.no_active_trip')}</Typography>
            </Card>
          )}
        </Box>
        <Box>
          <Modal
            aria-describedby='modal-modal-description'
            aria-labelledby='modal-modal-title'
            onClose={() => {
              setOpen6(false)
            }}
            open={open6}
          >
            <Box sx={style}>
              <MapContainer
                center={[
                  positionLast !== undefined ? positionLast?.gps?.latitude : [35.7219, 51.3347],
                  positionLast !== undefined ? positionLast?.gps?.longitude : [35.7219, 51.3347],
                ]}
                scrollWheelZoom={false}
                style={{ width: '100%', height: '100%', position: 'relative' }}
                zoom={13}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                />
                <Circle
                  center={[
                    positionLast !== undefined ? positionLast?.gps?.latitude : [35.7219, 51.3347],
                    positionLast !== undefined ? positionLast?.gps?.longitude : [35.7219, 51.3347],
                  ]}
                  radius={200}
                />
                <Marker
                  position={[
                    positionLast !== undefined ? positionLast?.gps?.latitude : [35.7219, 51.3347],
                    positionLast !== undefined ? positionLast?.gps?.longitude : [35.7219, 51.3347],
                  ]}
                >
                  <Popup>{address}</Popup>
                </Marker>
              </MapContainer>
              <IconButton
                onClick={() => {
                  setOpen6(false)
                }}
                sx={{
                  backgroundColor: 'red',
                  borderRadius: '50%',
                  color: '#fff',
                  zIndex: 1501,
                  position: 'absolute',
                  top: 2,
                  right: 2,
                  width: '21px',
                  height: '21px',
                }}
              >
                <ClearIcon sx={{ width: '16px' }} />
              </IconButton>
            </Box>
          </Modal>
        </Box>
        {listOpenTrips.length !== 0 && (
          <>
            <div className='content'></div>

            <Card
              sx={{
                color: '#fff',
                backgroundColor: '#EDE4E0',
                borderRadius: 1,
                p: 1,
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 0.5,
                direction: 'rtl',
                background: 'green',
                position: 'fixed',
                top: '160px',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: matches ? '380px' : '88%',
                height: '152px',
              }}
            >
              <Box display='flex' flexDirection='column' sx={{ direction: 'rtl', width: '100%' }}>
                <Typography>{t('screens.TripsCarScreen.start_address_trip')}</Typography>
                <Typography component={'span'} display='flex' sx={{ fontSize: 12 }}>
                  <PinDropRoundedIcon />
                  {listOpenTrips.startAddress}
                </Typography>
                <Typography>{t('screens.TripsCarScreen.start_date_trip')}</Typography>

                <Typography component={'span'} display='flex' sx={{ fontSize: 12 }}>
                  <AccessTimeFilledRoundedIcon />
                  {shamsi(listOpenTrips.creationDate)}
                </Typography>
                <Box sx={{ direction: 'ltr' }}>
                  <Button onClick={handleFinishTrip} sx={{ p: 0.5, mr: 1, bgcolor: '#8d8a8a' }}>
                    {t('screens.TripsCarScreen.finish_trip')}
                  </Button>
                  <Button
                    onClick={() => {
                      dispatch(tripDeleteOpen(listOpenTrips.id))
                    }}
                    sx={{ p: 0.5, bgcolor: '#8d8a8a' }}
                  >
                    {t('screens.TripsCarScreen.cancel_trip')}
                  </Button>
                </Box>
              </Box>
            </Card>
          </>
        )}
        <Box>
          <Fab
            aria-label='add'
            color='primary'
            onClick={handleClickOpen2}
            size='medium'
            sx={{ margin: '8px 0', width: '100%' }}
            variant='extended'
          >
            <AssessmentIcon sx={{ mr: 1 }} />
            {t('screens.TripsCarScreen.list_completed_trips')}
          </Fab>
          <Box
            sx={{
              maxHeight:
                listOpenTrips.length === 0
                  ? { xs: '57vh', sm: '57vh', md: '60vh', lg: '61vh' }
                  : { xs: '37vh', sm: '37vh', md: '41vh', lg: '41vh' },
              overflow: 'auto',
            }}
          >
            {tripsList?.length !== 0 &&
              tripsList?.map((p: any, index: number) => (
                <Card
                  key={p.id}
                  sx={{
                    color: 'gray',
                    backgroundColor: '#fff',
                    p: 1,
                    mb: 1,
                  }}
                >
                  <Box
                    display='flex'
                    flexDirection='column'
                    sx={{ direction: 'rtl', width: '100%' }}
                  >
                    <Box display='flex' justifyContent='space-between'>
                      <Typography>آدرس شروع سفر:</Typography>
                      <Typography component={'span'} display='flex' justifyContent='space-between'>
                        <Typography>سفر شماره</Typography>
                        <Typography
                          component={'span'}
                          sx={{
                            background: 'red',
                            color: 'white',
                            width: '25px',
                            mr: '10px',
                            textAlign: 'center',
                            borderRadius: '7px',
                          }}
                        >
                          {toFarsiDigits(index + 1)}
                        </Typography>
                      </Typography>
                    </Box>
                    <Typography
                      component={'span'}
                      display='flex'
                      sx={{ fontSize: 13, color: 'green' }}
                    >
                      <PinDropRoundedIcon />
                      {p.startAddress}
                    </Typography>
                    <Typography>آدرس پایان سفر:</Typography>

                    <Typography
                      component={'span'}
                      display='flex'
                      sx={{ fontSize: 13, color: 'red' }}
                    >
                      <PinDropRoundedIcon />
                      {p.endAddress}
                    </Typography>

                    <Box sx={{ direction: 'ltr' }}>
                      <Button
                        onClick={() => {
                          setOpen3(true)
                          setTrip(p)
                        }}
                        sx={{ p: 0.5, mr: 1, bgcolor: '#8d8a8a' }}
                      >
                        گزارش سفر
                      </Button>
                      <Button
                        onClick={() => {
                          dispatch(tripDelete(p.id))
                        }}
                        sx={{ p: 0.5, bgcolor: '#8d8a8a' }}
                      >
                        حذف سفر
                      </Button>
                    </Box>
                  </Box>
                </Card>
              ))}
            {tripsList?.length === 0 && isSearch && !loading && (
              <Card sx={{ p: 1, display: 'flex', justifyContent: 'center' }}>
                <Typography>هیچ سفری در این بازه زمانی وجود ندارد</Typography>
              </Card>
            )}
          </Box>
        </Box>
        <Box display='flex' justifyContent='center' width='100%'>
          <Button
            onClick={handleClickOpen}
            sx={{
              position: 'absolute',
              bottom: '7%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: matches ? '27%' : '90%',
            }}
          >
            {t('screens.TripsCarScreen.new_trip')}
          </Button>
        </Box>
        <div>
          <BootstrapDialog
            aria-labelledby='customized-dialog-title'
            open={open2}
            sx={{ direction: 'rtl', '& .MuiDialog-paper': { width: '400px' } }}
          >
            <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose2}>
              {t('screens.TripsCarScreen.choose_trip_time')}
            </BootstrapDialogTitle>
            <DialogContent
              dividers
              sx={{ background: 'linear-gradient(rgb(245 255 255), #aaaaaa)' }}
            >
              <Box
                sx={{
                  '& .rmdp-input': {
                    fontFamily: 'Vazir',
                    minHeight: '40px',
                    width: '100%',
                  },
                  '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                  '& .rmdp-container ': { width: '100%', fontFamily: 'Vazir' },
                  '& .rmdp-action-button': { fontFamily: 'Vazir' },
                }}
              >
                <Typography>{t('screens.TripsCarScreen.choose_trip_start_date')}</Typography>

                <div
                  style={{
                    // direction: 'rtl',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <DatePicker
                    calendar={persian}
                    calendarPosition='top-right'
                    className='rmdp-mobile'
                    format='YYYY/MM/DD'
                    locale={persian_fa}
                    maxDate={new DateObject({ calendar: persian })}
                    onChange={handleChange}
                    plugins={[<TimePicker hideSeconds key={''} position='bottom' />]}
                    render={<InputIcon />}
                    style={{ width: '100%' }}
                  />
                </div>
              </Box>

              <Box>
                <Typography>{t('screens.TripsCarScreen.choose_trip_end_date')}</Typography>
                <Box
                  sx={{
                    '& .rmdp-input': {
                      fontFamily: 'Vazir',
                      minHeight: '40px',
                      width: '100%',
                    },
                    '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
                    '& .rmdp-container ': {
                      width: '100%',
                      fontFamily: 'Vazir',
                    },
                    '& .rmdp-action-button': { fontFamily: 'Vazir' },
                  }}
                >
                  <div
                    style={{
                      // direction: 'rtl',
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <DatePicker
                      calendar={persian}
                      calendarPosition='top-right'
                      className='rmdp-mobile'
                      format='YYYY/MM/DD'
                      locale={persian_fa}
                      minDate={date1}
                      onChange={handleChangeDateTo}
                      plugins={[<TimePicker hideSeconds key={''} position='bottom' />]}
                      render={<InputIcon />}
                      style={{ width: '100%' }}
                    />
                  </div>
                </Box>
              </Box>
              <Box sx={{ mt: 1, direction: 'ltr', display: 'flex', justifyContent: 'center' }}>
                <ToggleButtonGroup
                  aria-label='Platform'
                  color='primary'
                  exclusive
                  onChange={handleChangeToggle}
                  sx={{ maxHeight: 90, background: 'linear-gradient(rgb(255 255 255), #aaaaaa)' }}
                  value={alignment}
                >
                  <ToggleButton onClick={handle2hourAgo} value='2hourAgo'>
                    <img src={iranflag2} width='30px' />
                  </ToggleButton>
                  <ToggleButton onClick={handle6hourAgo} value='6hourAgo'>
                    <img src={iranflag6} width='30px' />
                  </ToggleButton>
                  <ToggleButton onClick={handle12hourAgo} value='12hourAgo'>
                    <img src={iranflag12} width='30px' />
                  </ToggleButton>
                  <ToggleButton onClick={handleYesterdayDay} value='yesterday'>
                    <img src={iranflag24} width='30px' />
                  </ToggleButton>
                  <ToggleButton onClick={handle48hourAgo} value='48hourAgo'>
                    <img src={iranflag48} width='30px' />
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </DialogContent>
            <DialogActions sx={{ background: 'linear-gradient(rgb(168 169 169), #e7e1e1)' }}>
              <Box>
                <Button onClick={handleClose2} sx={{ ml: 1 }}>
                  {t('screens.TripsCarScreen.cancel_trip')}
                </Button>
                <Button onClick={handleShowTripList}>
                  {' '}
                  {t('screens.TripsCarScreen.show_trip')}
                </Button>
              </Box>
            </DialogActions>
          </BootstrapDialog>
        </div>

        <div>
          <BootstrapDialog
            aria-labelledby='customized-dialog-title'
            onClose={handleClose3}
            open={open3}
            sx={{ direction: 'rtl', '& .MuiDialog-paper': { width: '400px' } }}
          >
            <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose3}>
              گزارش سفر
            </BootstrapDialogTitle>
            <DialogContent dividers>
              {trip !== undefined && (
                <Box>
                  <Typography>مبدا:</Typography>
                  <Typography color={'red'}>{trip?.startAddress}</Typography>
                  <Typography>مقصد:</Typography>
                  <Typography color={'red'}>{trip?.endAddress}</Typography>
                  <Box display='flex'>
                    <Typography>تاریخ شروع سفر:</Typography>
                    <Typography color={'red'}>
                      {shamsi(trip?.startPosition?.gps?.dateTime)}
                    </Typography>
                  </Box>
                  <Box display='flex'>
                    <Typography>تاریخ پایان سفر:</Typography>
                    <Typography color={'red'}>
                      {shamsi(trip?.endPosition?.gps?.dateTime)}{' '}
                    </Typography>
                  </Box>
                  <Box display='flex'>
                    <Typography>زمان کلی سفر:</Typography>
                    <Typography color={'red'}>
                      {sf.convert(trip?.onTimeSeconds).format('HH:MM:SS')}{' '}
                    </Typography>
                  </Box>
                  <Box display='flex'>
                    <Typography>میانگین سرعت:</Typography>
                    <Typography color={'red'}>{_.split(trip?.avgSpeed, '.', 1)}Km </Typography>
                  </Box>
                  <Box display='flex'>
                    <Typography>مسافت طی شده:</Typography>
                    <Typography color={'red'}>{convertKilometer(trip?.totalDistance)} </Typography>
                  </Box>
                  <Box display='flex'>
                    <Typography>میزان مصرف سوخت:</Typography>
                    <Typography color={'red'}>{trip?.fuelConsumption} </Typography>
                  </Box>
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Box>
                <Button onClick={handleClose3} sx={{ ml: 1 }}>
                  بستن
                </Button>
              </Box>
            </DialogActions>
          </BootstrapDialog>
        </div>
        {/* ))} */}
      </Box>
    </Container>
  )
}

export default TripsCarScreen
